import type { DeviceSerialized } from '@playq/octopus2-devices';
import { KnownDevice, UnknownDevice } from '@playq/octopus2-devices';

export const checkNameInDevice = (device: DeviceSerialized) => {
  return 'name' in device ? new KnownDevice(device) : new UnknownDevice(device);
};
